import api from './api';

const BASE_PATH = '/admin/learning_paths';

/**
 * Cliente da API admin de trilhas (LearningPath).
 * Backend em backend/app/controllers/api/v1/admin/learning_paths_controller.rb.
 */
export const adminLearningPathsApi = {
  index: () => api.get(BASE_PATH),

  // body flat: { name, description, active, position }
  update: (id, payload) => api.patch(`${BASE_PATH}/${id}`, payload),

  // Alunos que iniciaram a trilha (1 linha por UserLearningPath).
  // Filtros de GRE/instituição/curso/turma: um id cada, vazio = sem filtro.
  students: (id, { q = '', page = 1, perPage = 25, regionalId, institutionId, courseId, classroomId } = {}) =>
    api.get(`${BASE_PATH}/${id}/students`, {
      params: {
        q: q || undefined,
        page,
        per_page: perPage,
        regional_id: regionalId || undefined,
        institution_id: institutionId || undefined,
        course_id: courseId || undefined,
        classroom_id: classroomId || undefined
      }
    }),

  // Drill-down de um aluno: blocos da trilha dele com estado.
  studentDetail: userLearningPathId => api.get(`/admin/user_learning_paths/${userLearningPathId}`),

  // Desempenho do aluno na trilha inteira: áreas → matérias → descritores.
  studentPerformance: userLearningPathId => api.get(`/admin/user_learning_paths/${userLearningPathId}/performance`)
};

export default adminLearningPathsApi;
